import { useDispatch } from 'react-redux';
import { setEditedConditionId } from '../../../../../redux/clinics/actions';

const useSetEditedCondition = () => {
  const dispatch = useDispatch();

  const setEditedCondition = (conditionId: string) => {
    dispatch(setEditedConditionId(conditionId));
  };

  return setEditedCondition;
};

export default useSetEditedCondition;
